var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('v-card-title',[_vm._v("Update details")]),_c('v-data-table',{attrs:{"headers":_vm.updatedHeaders,"items":_vm.updated,"disable-pagination":true,"hide-default-footer":true,"dense":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }